const InsectName = (productcode: string) => {
  let productname = "";

  switch (productcode) {
    case "INSECT1":
      productname = "흰점박이꽃무지";
      break;
    case "INSECT2":
      productname = "갈색거저리";
      break;
    case "INSECT3":
      productname = "누에";
      break;
    case "INSECT5":
      productname = "쌍별귀뚜라미";
      break;
    case "INSECT7":
      productname = "백견(누에)";
      break;
    case "INSECT8":
      productname = "황견(누에)";
      break;
    case "INSECT9":
      productname = "나용(누에)";
      break;
    case "INSECT10":
      productname = "삼면잠(누에)";
      break;
  }
  return productname;
};

export default InsectName;
